<template>
  <div class="page-container">
    <page-bar :title="title" :showBack="showBack">
      <template v-slot:actions v-if="actions != null">
        <v-btn
          v-for="(a, idx) in actions"
          :key="idx"
          elevation="0"
          @click="a.action()"
          class="secondary--text"
          color="primary"
          >{{ a.name }}</v-btn
        >
      </template>
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
        <slot v-if="slot == 'subactionView'" :name="slot" v-bind="scope"></slot>
      </template>
    </page-bar>

    <div class="page-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import PageBar from '@/components/PageBar.vue'

export default {
  props: {
    title: {
      type: [String, Array],
    },
    showBack: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      validator: (acts) => {
        for (const obj in acts) {
          if (
            typeof acts[obj].name !== 'string' ||
            typeof acts[obj].action !== 'function'
          ) {
            console.error(
              'Each action object must contain a `name` string and `action` function'
            )
            return false
          }
        }
        return true
      },
    },
  },
  components: {
    PageBar,
  },
}
</script>

<style lang="sass" scoped>
.page-container
  width: 100%
  min-height: 100%
  margin: 0px
  padding: 0px

.page-content
  padding: 20px
  margin: 0px
</style>
